var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0607 1.93934C32.6464 2.52513 32.6464 3.47487 32.0607 4.06066L15.0607 21.0607C14.4749 21.6464 13.5251 21.6464 12.9393 21.0607C12.3536 20.4749 12.3536 19.5251 12.9393 18.9393L29.9393 1.93934C30.5251 1.35355 31.4749 1.35355 32.0607 1.93934Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0676 3.5C30.0255 3.5 29.9738 3.50692 29.9199 3.52374L3.73992 11.6772L14.6261 18.505L15.1641 18.8361L15.4952 19.3741L22.3188 30.2537L30.4698 4.07554L30.4716 4.06978C30.4919 4.00539 30.4965 3.95975 30.4969 3.92986C30.4973 3.89913 30.4935 3.87196 30.4867 3.84613C30.472 3.78996 30.442 3.73461 30.4084 3.68838C30.3124 3.55791 30.1728 3.5 30.0676 3.5ZM29.0265 0.659872C29.3649 0.55428 29.7176 0.5 30.0676 0.5C31.1646 0.5 32.1901 1.043 32.8303 1.91792L32.8318 1.91992C33.1925 2.41463 33.7897 3.51999 33.3334 4.96973C33.3331 4.97087 33.3327 4.97202 33.3323 4.97317L24.978 31.8045L24.9216 31.916C24.3243 33.0977 23.1742 33.5 22.3314 33.5C21.8441 33.5 21.1152 33.3733 20.4559 32.8044L20.2849 32.657L12.9839 21.0163L1.33693 13.7113L1.18635 13.5333C0.63446 12.8811 0.3849 12.0097 0.550267 11.1352C0.713231 10.2548 1.26032 9.49711 2.07345 9.07784L2.18983 9.01783L29.0251 0.660305C29.0256 0.66016 29.026 0.660016 29.0265 0.659872Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic_share.643a03344169e9707017e5d81bb6921a.svg";
export { ForwardRef as ReactComponent };